import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PictureInPictureContextType {
  isPiPOpen: boolean;
  openPiP: () => void;
  closePiP: () => void;
  togglePiP: () => void;
}

const PictureInPictureContext = createContext<PictureInPictureContextType | undefined>(undefined);

interface PictureInPictureProviderProps {
  children: ReactNode;
}

export const PictureInPictureProvider: React.FC<PictureInPictureProviderProps> = ({ children }) => {
  const [isPiPOpen, setIsPiPOpen] = useState(false);

  const openPiP = () => {
    setIsPiPOpen(true);
  };

  const closePiP = () => {
    setIsPiPOpen(false);
  };

  const togglePiP = () => {
    setIsPiPOpen(!isPiPOpen);
  };

  const value: PictureInPictureContextType = {
    isPiPOpen,
    openPiP,
    closePiP,
    togglePiP,
  };

  return (
    <PictureInPictureContext.Provider value={value}>
      {children}
    </PictureInPictureContext.Provider>
  );
};

export const usePictureInPicture = (): PictureInPictureContextType => {
  const context = useContext(PictureInPictureContext);
  if (context === undefined) {
    throw new Error('usePictureInPicture must be used within a PictureInPictureProvider');
  }
  return context;
};

